module.exports = __webpack_public_path__ + "assets/7fe87f85799a6d16fd487a8eedc4a1f8.mp3";